import React from 'react'
import Layout from '../components/layout'

function Users() {
    return (
        <Layout>
            <div>Users</div>d
        </Layout>
    )
}

export default Users